import type { Token, TokenNormalized, TokenNormalizedSet } from '@terrazzo/parser';

export const FORMAT_ID = 'js';

export const DEFAULT_PROPERTIES: Set<keyof TokenNormalized> = new Set([
  '$type',
  '$value',
  '$description',
  '$extensions',
  '$deprecated',
  // 'id',
  // 'jsonID',
  // 'aliasOf',
  // 'aliasChain',
  // 'aliasedBy',
  // 'dependencies',
  // 'group',
]);

export interface JSPluginOptions<T extends Record<string, string> = Record<string, string>> {
  /**
   * Change the output filename
   * @default "index.js"
   */
  filename?: string;
  /** Only generate permutations for the specified modifiers (by default, generate all permutations) */
  contexts?: { [key in keyof T]: T[keyof T][] };
  /** Only include specified properties as part of token output. */
  properties?: (keyof TokenNormalized)[];
}

export type Resolver<T extends Record<string, string>> = (input: T) => TokenNormalizedSet;

export const FILE_HEADER = `/** ------------------------------------------
 *  Autogenerated by ⛋ Terrazzo. DO NOT EDIT!
 * ------------------------------------------- */`;

export const TYPE_MAP: Record<Token['$type'], string> = {
  boolean: 'BooleanTokenNormalized',
  border: 'BorderTokenNormalized',
  color: 'ColorTokenNormalized',
  cubicBezier: 'CubicBezierTokenNormalized',
  dimension: 'DimensionTokenNormalized',
  duration: 'DurationTokenNormalized',
  fontFamily: 'FontFamilyTokenNormalized',
  fontWeight: 'FontWeightTokenNormalized',
  gradient: 'GradientTokenNormalized',
  link: 'LinkTokenNormalized',
  number: 'NumberTokenNormalized',
  shadow: 'ShadowTokenNormalized',
  string: 'StringTokenNormalized',
  strokeStyle: 'StrokeStyleTokenNormalized',
  typography: 'TypographyTokenNormalized',
  transition: 'TransitionTokenNormalized',
};
